import type { ReferralStatus } from 'prismas';
import type { ReferralTypes, ZInfer, addressSchemaOptionalState, referralSchemas } from 'types';
import { Api } from '../fetch';

export class ReferralNet {
  static admin = {
    sync: (lastSync: Date = new Date(0)) =>
      Api.get<'referralAdmin', 'sync'>('/referral/admin/sync', { query: { lastSync } }),
    loadMore: (currentLast: Date, all?: boolean) =>
      Api.get<'referralAdmin', 'load'>('/referral/admin/load', { query: { currentLast, all } }),
    updateStatus: (id: string, status: ReferralStatus | 'REOPEN') =>
      Api.patch<'referralAdmin', 'updateStatus'>('/referral/admin/status', { body: { id, status } }),
    updateReferralAdminMeta: (body: ZInfer<typeof referralSchemas.adminMeta.request>) =>
      Api.post<'referralAdmin', 'upsertAdminMeta'>('/referral/admin/meta/admin', { body }),
    updateReferralMeta: (body: ZInfer<typeof referralSchemas.meta.request>) =>
      Api.post<'referralAdmin', 'upsertMeta'>('/referral/admin/meta', { body }),
    notifyNewNotes: (referralId: string) =>
      Api.get<'referralAdmin', 'notifyOfNotes'>('/referral/admin/notify/note', { query: { id: referralId } }),
    searchLocation: (body: ZInfer<typeof addressSchemaOptionalState>) =>
      Api.post<'referralAdmin', 'searchLocation'>('/referral/admin/location/search', { body }),
    agency: {
      getOne: (id: string) => Api.get<'agency', 'getOne'>('/agency/:id', { params: { id } }),
      removeAgent: (id: string, agentId: string) =>
        Api.delete<'agency', 'removeAgent'>('/agency/:id/agent/:agentId', { params: { id, agentId } }),
      upsert: (body: ZInfer<typeof referralSchemas.agency>) => Api.post<'agency', 'upsert'>('/agency', { body }),
      delete: (id: string) => Api.delete<'agency', 'delete'>('/agency/:id', { params: { id } }),
    },
  };
  static general = {
    upsert: (body: ZInfer<typeof referralSchemas.draft>) => Api.post<'referral', 'upsert'>('/referral', { body }),
    submit: (body: ZInfer<typeof referralSchemas.referral>) =>
      Api.post<'referral', 'submit'>('/referral/submit', { body }),
    getMy: (page: number = 1) => Api.get<'referral', 'getMy'>('/referral/my', { query: { page } }),
    get: <T extends ReferralTypes['referral'] | ReferralTypes['adminReferral'] = ReferralTypes['referral']>(
      id: string,
    ) => Api.get<'referral', 'get', T>('/referral/:id', { params: { id } }),
    delete: (id: string) => Api.delete<'referral', 'delete'>('/referral/:id', { params: { id } }),
  };
}
